import moment from "moment-timezone"

export function getLastMonth() {
  return {
    from: moment().subtract(30, "days").startOf("day").format("YYYY-MM-DD"),
    to: moment().endOf("day").format("YYYY-MM-DD"),
  }
}
